export default __webpack_public_path__ + "static/media/subscribe.960fa3c3.png";